import React from "react";
import CircularDiagram from "./CircularDiagram";
import { CenteredSiteBlock } from "../../routes/Home";
import { Box, Grid, styled, Typography, useTheme } from "@mui/material";
import { ReactComponent as ZoomWeird } from "../..//resources/images/svg/home/zoomIcon.svg";
import { useIsMobile } from "../../hooks/responsive";
import HomeHeroCards from "./HomeHeroCards";
import InexButton from "../InexButton";

import weirdBackground from "../../resources/images/svg/home/weirdBackground.svg";

import One from "../../resources/images/png/home/hero/1.png";
import Two from "../../resources/images/png/home/hero/2.png";
import Three from "../../resources/images/png/home/hero/3.png";
import Four from "../../resources/images/png/home/hero/4.png";
import Five from "../../resources/images/png/home/hero/5.png";
import Six from "../../resources/images/png/home/hero/6.png";
import Seven from "../../resources/images/png/home/hero/7.png";
import Eight from "../../resources/images/png/home/hero/8.png";
import { useIsSubscribed } from "../../hooks/auth";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100px",
    backgroundColor: "#0D0034",
    paddingBottom: theme.spacing(5),
  };
});

const circleItems = [
  {
    image: One,
    label: "Psychologies et psychothérapies",
  },
  {
    image: Two,
    label: "Approches corporelles",
  },
  {
    image: Three,
    label: "Techniques énergétiques et vibratoires",
  },
  {
    image: Four,
    label: "Harmonisation des lieux",
  },
  {
    image: Five,
    label: "Soins naturels",
  },
  {
    image: Six,
    label: "Langages sacrés",
  },
  {
    image: Seven,
    label: "Guidances spirituelles",
  },
  {
    image: Eight,
    label: "Thérapies brèves",
  },
];

const redirectToSubscribe = () => {
  window
    .open(
      `https://abonnements.inexplore.com/je-mabonne?selectedAbos=[3,4]`,
      "_blank",
    )
    .focus();
};

const redirectToGiftCard = () => {
  window
    .open(
      `https://abonnements.inexplore.com/offrir?selectedAbos=[3,4]`,
      "_blank",
    )
    .focus();
};

const HomeHero = () => {
  const isMobile = useIsMobile();

  const isSubscribed = useIsSubscribed();

  return (
    <Container className={"home-hero"}>
      <CenteredSiteBlock
        sx={{
          background: `url(${weirdBackground})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "stretch",
          backgroundPosition: "bottom",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              height: "400px",
              top: 0,
              background: "linear-gradient(0deg, #0D0034 0.3%, #9A45F4 100%)",
              opacity: 0.5,
            }}
          />
          <Typography
            mt={4}
            variant="h1"
            sx={{
              color: "white",
              fontSize: "48px",
              zIndex: 1,
              textAlign: "center",
            }}
          >
            Cultivez des synergies holistiques
          </Typography>
          <Typography
            mt={3}
            variant="h3"
            sx={{
              color: "white",
              fontFamily: "Branding Medium",
              zIndex: 1,
              textAlign: "center",
              margin: isMobile ? "20px 5vw" : undefined,
            }}
          >
            Rejoignez un réseau de professionnels pluridisciplinaires de
            l'accompagnement, du soin et de la conscience, pour faire évoluer
            les pratiques vers plus de cohérence et
            <span
              style={{
                fontFamily: "Branding Bold",
              }}
            >
              {" "}
              d'efficacité thérapeutique globale.
            </span>
          </Typography>
          <CircularDiagram
            items={circleItems}
            offset={isMobile ? 150 : 220}
            sx={{
              zIndex: 1,
            }}
          >
            {<ZoomWeird width={"100%"} height={"100%"} />}
          </CircularDiagram>
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontFamily: "YesevaOne",
              fontSize: "28px",
              zIndex: 1,
              textAlign: "center",
              mb: 5,
            }}
          >
            Participez au mouvement et...
          </Typography>
          <HomeHeroCards
            sx={{
              zIndex: 1,
            }}
          />
          <Grid
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              marginRight: "5vw",
              marginLeft: "5vw",
              marginBottom: 5,
              marginTop: 5,
              gap: 2,
            }}
          >
            <InexButton
              text={"Je m'abonne à Inexploré Praticiens"}
              variant={"text"}
              textWithGradient={false}
              onClick={redirectToSubscribe}
              sx={{
                zIndex: 1,
                width: "300px",
                height: "50px",
                background: (theme) => theme.palette.yellowPro,
                border: (theme) => theme.palette.yellowPro + " solid 3px",
                color: "#202020",
                "&:hover": {
                  backgroundColor: "white",
                  "& > p": {
                    color: "#202020",
                  },
                },
              }}
            />

            <InexButton
              text={"J'offre cet abonnement"}
              variant={"text"}
              textWithGradient={false}
              onClick={redirectToGiftCard}
              sx={{
                zIndex: 1,
                width: "250px",
                height: "50px",
                background: (theme) => theme.palette.primary.main,
                border: (theme) => theme.palette.primary.main + " solid 3px",
                color: "white",
                "&:hover": {
                  backgroundColor: "white",
                  "& > p": {
                    color: (theme) => theme.palette.primary.main,
                  },
                },
              }}
            />

          </Grid>
        </Box>
      </CenteredSiteBlock>
    </Container>
  );
};

export default HomeHero;
